import { Component, ContentChildren, Input, QueryList } from '@angular/core';
import { ListFlatItemComponent } from './list-flat-item.component';

@Component({
    selector: 'list-flat',
    templateUrl: 'list-flat.component.html',
    styleUrls: ['list-flat.component.scss'],
})
export class ListFlatComponent {
    @Input() public icon: string;
    @Input() public svg: boolean = false;
    @Input() public usp: boolean = false;
    @Input() public expanded: boolean = false;
    @Input() public numbered: boolean = false;
    @Input() public lined: boolean = false;
    @Input() public table: boolean = false;

    @ContentChildren(ListFlatItemComponent) listFlatItems!: QueryList<ListFlatItemComponent>;

    // --- Tracking

    trackByIndex(index: number): number {
        return index;
    }
}
